import { css } from 'styled-components';
import '../fonts/Poppins.css';

export const GlobalFontFamily = css`
  font-family: 'Poppins-Light', Arial, Helvetica, sans-serif;
`;
